import React, { useRef, useState } from 'react';

import "assets/scss/billingPortal/modules/reporting/invoiceCommission.scss";
import MonthlyReport from './reportTypes/MonthlyReport';
import MainReport from './reportTypes/MainReport';

export default function InvoiceCommission() {
    const [isMonthlyReportVisible, setIsMonthlyReportVisible] = useState();
    const [selectedDealerMonthly, setSelectedDealerMonthly] = useState();
    const [selectedDate, setSelectedDate] = useState();

    const queries = useRef({});

    return (
        <div>
            <div className={isMonthlyReportVisible? "":"d-none"}>
                <MonthlyReport queries={queries}
                    isMonthlyReportVisible={isMonthlyReportVisible}
                    setIsMonthlyReportVisible={setIsMonthlyReportVisible}
                    selectedDealerMonthly={selectedDealerMonthly}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                />
            </div>

            <div className={isMonthlyReportVisible? "d-none":""}>
                <MainReport queries={queries}
                    setIsMonthlyReportVisible={setIsMonthlyReportVisible}
                    setSelectedDealerMonthly={setSelectedDealerMonthly}
                    selectedDealerMonthly={selectedDealerMonthly}
                    setSelectedDate={setSelectedDate}
                />
            </div>
        </div>
    );
}